
export const spiPinCodeTemplate = `pinmux_spi_config({name}, {signal});`;




export const spiCodeTemplate = `

#include "driver_pinmux.h"
#include "driver_spi.h"

/*!
    \\brief      user SPI configure function
    \\param[in]  none
    \\param[out] none
    \\retval     none
*/
int mx_spi_init(void)
{
    spi_parameter_struct spi_init_struct;
    /* deinitialize SPI and the parameters */
    {pinsCode}

    spi_i2s_deinit({instance});
    spi_struct_para_init(&spi_init_struct);

    /* configure {instance} parameter */
    spi_init_struct.frame_size           = {DataSize};
    spi_init_struct.endian               = {FirstBit};
    spi_init_struct.prescale             = {BaudRatePrescaler};
    spi_init_struct.device_mode          = {Mode};
    spi_init_struct.clock_polarity_phase = ({CLKPolarity} | {CLKPhase});
    spi_init_struct.nss                  = {NSS};
    spi_init({instance}, &spi_init_struct);
}

`;
